import React, { ChangeEvent, FC, useContext, useEffect, useState } from "react";
import SearchBox from "../search-box-mediadores/search-box";
import { NationalitySelectProps } from "./nationality-select.types";
import { GeneralContext } from "../../context/constants";
import { getCountriesList } from "../../utils/countries";
import { getFilteredCountries } from "../../utils/validation";

const NationalitySelect: FC<NationalitySelectProps> = ({
  nationalityValue,
  nationalityError,
  onSelect,
  required = false,
  disabled = false,
}) => {
  const generalContext: any = useContext(GeneralContext);
  const [countriesList, setCountriesList] = useState<{ label: string; value: string }[]>([]);
  const [countriesFiltered, setCountriesFiltered] = useState<{ label: string; value: string }[]>([]);

  useEffect(() => {
    fetchCountries();
  }, []);

  const fetchCountries = async() => {
    const countries = await getCountriesList(generalContext.countries);
    setCountriesList(countries);  
  }

  const changeValue = (ev: ChangeEvent<HTMLInputElement>) => {
    const value: string = ev.target.value;

    if (value.length < 2) return;

    setCountriesFiltered(
      getFilteredCountries(value, countriesList)
    );
  };
  return (
    <div className="inputBox">
      <SearchBox
        onChange={(ev: ChangeEvent<HTMLInputElement>) => changeValue(ev)}
        labelText=""
        optionsText={countriesFiltered}
        optionKey={"value"}
        optionValue={"label"}
        disabled={disabled}
        initialValue={nationalityValue}
        required={required}
        errorCode={nationalityError}
        onSelect={(value: { value: string; label: string }) => {
          onSelect(value.label, value.value);
        }}
        notScroll
      />
      <label>Nacionalidad</label>
    </div>
  );
};

export default NationalitySelect;
